import { CommonModule } from '@angular/common';
import { AppConstants } from 'src/app/shared/constants/constants';
import { Component, input, OnInit, OnDestroy, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '../../service/language.service';
import { TranslationService } from '../../service/translation.service';
import { StoreManagerService } from '../../store-manager/services/store-manager.service';
import { CrowdinOtaService } from '../../service/crowdin-ota/crowdin-ota.service';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { LoadingSpinnerService } from '../../service/loading-spinner.service';

@Component({
  selector: 'app-language-selection',
  templateUrl: './language-selection.component.html',
  styleUrls: ['./language-selection.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule],
})
export class LanguageSelectionComponent implements OnInit, OnDestroy {

  private readonly _languageService = inject(LanguageService)
  private _crowdinOtaService = inject(CrowdinOtaService)
  private location = inject(Location)
  private _router = inject(Router)
  private _loadingSpinnerService = inject(LoadingSpinnerService)
  private readonly _translationService = inject(TranslationService)
  private readonly _storeManagerService = inject(StoreManagerService)

  readonly showLanguageSelectionModal = input<boolean>(false);
  translationData: any;
  allLanguages: any[] = [];
  BUTTON_NAMES = AppConstants.COMMON_BUTTON_LABELS;

  constructor() {
    this._storeManagerService.getUserSelectedLanguageFromStore();
  }

  ngOnInit(): void {
    this.allLanguages = this._translationService.supportedLanguagesForDisplay;
  }

  public closeLangSelection(): void {
    this._languageService.showLanguageModalState.set(false);
  }

  public async switchLanguage(language: string): Promise<void> {
    const pattern = /\/[a-z]{2}-[A-Z]{2}(?=\/|$)/;
    const currentUrl = this._router.url;
    let updatedUrl = currentUrl;
    this._loadingSpinnerService.show();
    if (pattern.test(currentUrl)) {
      updatedUrl = currentUrl.replace(pattern, `/${language}`);
    } else {
      // If no language pattern found, prepend the language to the URL
      updatedUrl = `/${language}${currentUrl}`;
    }

    this.location.replaceState(updatedUrl);
    const languageCode = language.split('-')[0];

    try {
      await this._crowdinOtaService.useLanguage(languageCode);
      console.log(`Switched to ${languageCode}`);
      setTimeout(() => {
        this._storeManagerService.setUserLanguageToStore(language);
        this._loadingSpinnerService.hide();
        this.closeLangSelection();
      }, 10);
    } catch (error) {
      console.error('Error switching language:', error);
    }
  }

  ngOnDestroy(): void {
    this._languageService.showLanguageModalState.set(false);
  }

}